import { ConfirmationDialogRaw } from "@/controls/modals/ConfirmationDialogRaw";
import { NotificationSnackBar } from "@/controls/snackbars/notification-snackbar";
import { upsertHeat } from "@/pages/meltshop/heats/repositories/heatsRepository";
import { GradeSelector } from "@/shared/GradeSelector";
import { ButtonWithLoading, ErrorModal, MesfModal } from "@dexteel/mesf-core";
import { Button, Grid2 as Grid } from "@mui/material";
import { useEffect, useState } from "react";

interface Props {
	show: boolean;
	onClose: (shouldUpdate?: boolean) => void;
	gradeId: number | null;
	heatId: number | null;
}

export const EditCastedGrade = ({ show, onClose, gradeId, heatId }: Props) => {
	const [selectedGrade, setSelectedGrade] = useState<number | null>(gradeId);
	const [openAlert, setOpenAlert] = useState<boolean>(false);
	const [error, setError] = useState<string>("");
	const [submitMessage, setSubmitMessage] = useState<string>("");
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const handleChangeCastedGrade = async () => {
		if (gradeId !== null) {
			setOpenAlert(true);
		} else {
			await upsertGrade();
		}
	};

	const upsertGrade = async () => {
		setIsLoading(true);
		const resp = await upsertHeat({
			HeatId: heatId,
			GradeId: selectedGrade,
		});
		if (resp.ok) {
			setSubmitMessage("Grade updated successfully");
			onClose(true);
		} else {
			setError(resp.message);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		if (show) {
			setSelectedGrade(gradeId);
		}
	}, [show]);

	return (
		<>
			<MesfModal
				title="Modify Cast Grade"
				open={show}
				id="confirm-modal"
				handleClose={() => onClose(false)}
			>
				<MesfModal.Content style={{ padding: "15px 30px" }}>
					<Grid container spacing={1}>
						<Grid size={{ xs: 12, md: 12 }}>
							<GradeSelector
								value={selectedGrade}
								onChange={setSelectedGrade}
								disabled={false}
								label="Select a Grade"
							/>
						</Grid>
					</Grid>
				</MesfModal.Content>
				<MesfModal.Actions>
					<Grid container spacing={2} justifyContent="flex-end">
						<Grid size={{ xs: 12, md: 3 }}>
							<Button
								fullWidth
								variant="contained"
								color="inherit"
								onClick={() => {
									onClose();
								}}
							>
								Cancel
							</Button>
						</Grid>
						<Grid size={{ xs: 12, md: 3 }}>
							<ButtonWithLoading
								fullWidth
								variant="contained"
								color="primary"
								type="submit"
								onClick={handleChangeCastedGrade}
								isLoading={isLoading}
							>
								Save
							</ButtonWithLoading>
						</Grid>
					</Grid>
				</MesfModal.Actions>
			</MesfModal>

			<ConfirmationDialogRaw
				title="Confirm change"
				message="Are you sure you want to change the Cast Grade?"
				open={openAlert}
				onClose={(value) => {
					if (value === "OK") {
						upsertGrade();
					}
					setOpenAlert(false);
				}}
			/>
			<NotificationSnackBar
				message={submitMessage}
				onHide={() => setSubmitMessage("")}
			/>
			<ErrorModal error={error} onHide={() => setError("")} title="Error" />
		</>
	);
};
